import Raven from 'raven-js';

if (process.env.NODE_ENV === 'production') {
  Raven.config(
    'https://3720836a1b774ef3b08dc0e17f899eb3@sentry.io/298391',
  ).install();
}
